import { OreHero, OreIcon, OreStack, OreText, SvgCompany, SvgPhone } from '@edenredespana/oreneta'
import { Trans, useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { SignUpTranslation } from '@/AutoEnrollment/ui/autoEnrollmentTranslation'
import { CursorIcon } from '@/Shared/ui/assets/CursorIcon'
import { CONTACT_PHONE } from '@/Shared/domain/constants/globals'
import { openNavigationRoutes } from '@/Shared/ui/routers'


export const SignUpHeader = (): JSX.Element => {
    const { t } = useTranslation()
    const navigate = useNavigate()

    return (
        <OreStack space="xsmall">
            <div className="signup-hero-override">
                <OreHero
                    title={t(SignUpTranslation.pageTitle)}
                    subtitle={t(SignUpTranslation.pageSubTitle)}
                    titleSize="title-md"
                />
            </div>

            <OreStack space="xsmall" direction="column" style={{ marginBottom: '32px' }}>
                <OreStack space="xsmall" direction="row" placeItems="center" style={{ marginBottom: '16px' }}>
                    <OreText bold>{t(SignUpTranslation.infoList.title)}</OreText>
                </OreStack>
                <OreStack space="xsmall" direction="row" placeItems="center" style={{ marginLeft: '16px' }}>
                    <OreIcon icon={<SvgPhone />} size="2-extra-small" tone="neutral-600" />
                    <OreText><Trans i18nKey={SignUpTranslation.infoList.phone} values={{ phone: CONTACT_PHONE }} /></OreText>
                </OreStack>
                <OreStack space="xsmall" direction="row" placeItems="center" style={{ marginLeft: '16px' }}>
                    <OreIcon icon={<SvgCompany />} size="2-extra-small" tone="neutral-600" />
                    <OreText><Trans i18nKey={SignUpTranslation.infoList.group} /></OreText>
                </OreStack>
                <OreStack space="xsmall" direction="row" placeItems="center" style={{ marginLeft: '16px' }}>
                    <span style={{ width: '16px', display: 'flex' }}><CursorIcon /></span>
                    <OreText>
                        <Trans
                            i18nKey={SignUpTranslation.infoList.existingAccount}
                            components={{
                                a: <span
                                    style={{ textDecoration: 'underline', cursor: 'pointer', fontWeight: 'bold' }}
                                    onClick={() => navigate(openNavigationRoutes.login)}
                                />
                            }}
                        />
                    </OreText>
                </OreStack>
            </OreStack>
        </OreStack>
    )
}
